// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".var-row[data-v-47e6bc10]{display:grid;grid-template-columns:1fr 1fr 1fr 1fr 100px;grid-column-gap:20px;margin-bottom:10px;align-items:center}.var-row .single-value[data-v-47e6bc10]{grid-column:span 2}.var-row .remove BUTTON[data-v-47e6bc10]{padding:0}", ""]);
// Exports
module.exports = exports;
